import React from "react"

import { SimpleMetricCard } from "components/Shared/MetricCard"
import { CommercialBenchmarkVsmNode } from "components/Transactional/Performance/components/SummaryTable/SummaryTable.domain"

import useVsmConfig from "./useVsmConfig"

interface VsmData {
	vsmItems: CommercialBenchmarkVsmNode[]
}

const ValueShareModelContainer: React.FC<VsmData> = (props) => {
	const { vsmItems } = props
	const { nodeToTableFormat } = useVsmConfig()

	return (
		<>
			{vsmItems.map((node) => {
				const config = nodeToTableFormat(node)

				return (
					<SimpleMetricCard
						key={node.identifierName}
						title={config.title}
						content={config.content}
						value={config.principalMetric}
						legend={config.legend}
						headers={config.headers}
						data={config.data}
					/>
				)
			})}
		</>
	)
}

export default ValueShareModelContainer
